import { render, staticRenderFns } from "./PrepaymentTable.vue?vue&type=template&id=3c783b21&"
import script from "./PrepaymentTable.vue?vue&type=script&lang=ts&"
export * from "./PrepaymentTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports